export type StaffStudentBilling = {
  type: "monthly" | "class_wise" | null;
  label: "Monthly" | "Class-wise" | null;
  amount: number | null;
  formatted_amount: string | null;
  frequency_label: "/month" | "/class" | null;
  display: string; // e.g. "$130.00/month", "Amount not set", "Billing not configured"
};

export type StaffStudent = {
  student_id: number;
  student_name: string;
  reference_id: string | null;
  grade: string | null;
  subject: string | null;
  billing: StaffStudentBilling;
};

export type PaymentTypeFilter = "monthly" | "class_wise" | "not_configured";

export type StaffClassBlock = {
  occurrence_id: number;
  class_id: number;
  start_time: string | null;
  end_time: string | null;
  mode: string | null;
  location: string | null;
  location_id: number | null;
  capacity: number | null;
  enrolled_count: number;
  program_type: string | null;
  class_type: string | null;
  students: StaffStudent[];
};

export type StaffDay = {
  date: string;
  weekday: string;
  day: string;
  classes: StaffClassBlock[];
};

export type StaffBlock = {
  staff_id: number | null;
  staff_name: string;
  week_start: string;
  week_end: string;
  summary: {
    classes: number;
    students: number;
    teaching_hours: number;
    online: number;
    in_person: number;
    hybrid: number;
    zero_student: number;
    locations: string[];
  };
  days: StaffDay[];
};

export type StaffIndexItem = {
  staff_id: number | null;
  staff_name: string;
  class_count: number;
};

export type Options = {
  grades: { id: number; label: string }[];
  subjects: { id: number; label: string }[];
  staff: { id: number; label: string; reference_id: string | null }[];
  locations: { id: number; label: string }[];
  study_modes: { value: string; label: string }[];
  program_types: string[];
  class_types: string[];
};

export type FilterState = {
  week_start: string;
  date_from: string;
  date_to: string;
  staff_ids: number[];
  location_ids: number[];
  study_modes: string[];
  grade_ids: number[];
  subject_ids: number[];
  program_types: string[];
  class_types: string[];
  include_zero_student: boolean;
  include_one_off: boolean;
  include_inactive_staff: boolean;
  staff_search: string;
  payment_type: PaymentTypeFilter[];
};

function mondayOf(d: Date): string {
  const day = d.getDay();
  const diff = (day === 0 ? -6 : 1 - day);
  const mon = new Date(d);
  mon.setDate(d.getDate() + diff);
  const y = mon.getFullYear();
  const m = String(mon.getMonth() + 1).padStart(2, "0");
  const dd = String(mon.getDate()).padStart(2, "0");
  return `${y}-${m}-${dd}`;
}

export const defaultFilter = (): FilterState => ({
  week_start: mondayOf(new Date()),
  date_from: "",
  date_to: "",
  staff_ids: [],
  location_ids: [],
  study_modes: [],
  grade_ids: [],
  subject_ids: [],
  program_types: [],
  class_types: [],
  include_zero_student: false,
  include_one_off: false,
  include_inactive_staff: false,
  staff_search: "",
  payment_type: [],
});
